import { Injectable } from '@angular/core';
import { BaseHttpService } from '@shared/abstractions/base-http.service';
import { Observable } from 'rxjs';
import { CreateUserAttributionDto } from './marketing-attribution.types';

@Injectable({
  providedIn: 'root',
})
export default class MarketingAttributionApiService extends BaseHttpService {
  constructor() {
    super('marketing/attribution');
  }

  public createAttribution(dto: CreateUserAttributionDto): Observable<void> {
    return this.post<void>('', dto);
  }
}
